<template>
  <div class="footer text-c12 d-flex justify-center items-center gap-14 text-medium">
    <div class="item color-on-cont-dim text-c12">
      <a href="https://www.zarinpal.com/terms.html" target="_blanck"> قوانین و مقررات </a>
    </div>
    <div class="divider bg-on-cont-dim color-on-cont-dim"></div>
    <div class="item color-on-cont-dim text-c12">
      <a href="https://www.zarinpal.com/contact.html" target="_blanck"> پشتیبانی </a>
    </div>
    <div class="divider bg-on-cont-dim color-on-cont-dim"></div>
    <div class="item color-on-cont-dim text-c12">
      <a href="https://www.zarinpal.com/aboutus.html" target="_blanck">درباره ما</a>
    </div>
    <template v-if="!hideReportProblem">
      <div class="divider bg-on-cont-dim color-on-cont-dim"></div>
      <div class="item color-on-cont-dim text-c12">
        <span @click="openReportProblemModal">گزارش تخلف</span>
      </div>
    </template>
  </div>
  <ReportProblemModal :isOpen="reportProblemModal" :onClose="closeReportProblemModal" :openSuccessModal="openSuccessModal" />
  <SuccessModal :isOpen="isOpenSuccessModal" :onClose="closeSuccessModal" />
</template>
<script setup lang="ts">
import { ref } from 'vue';

import ReportProblemModal from '@/components/report-problem-modal/index.vue';
import SuccessModal from '@/components/report-problem-modal/success-modal.vue';
defineProps<{
  hideReportProblem?: boolean;
}>();
const reportProblemModal = ref<boolean>(false);
const isOpenSuccessModal = ref<boolean>(false);
const openReportProblemModal = () => (reportProblemModal.value = true);
const openSuccessModal = () => (isOpenSuccessModal.value = true);
const closeReportProblemModal = () => (reportProblemModal.value = false);
const closeSuccessModal = () => (isOpenSuccessModal.value = false);
</script>
<style lang="scss" scoped>
@import url('./index.scss');
</style>
